<svg [attr.width]="width" [attr.height]="height" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="25" height="25" rx="12.5" [attr.fill]="backgroundColor"/>
    <path d="M16 16L10 10M16 10L10 16" [attr.stroke]="strokeColor" stroke-width="2" stroke-linecap="round"/>
    <rect x="0.5" y="0.5" width="25" height="25" rx="12.5" [attr.stroke]="backgroundColor"/>
</svg>
